import React, { useEffect } from 'react'
import CreateFirstStep from './initialCreation/CreateFirstStep'
import AiGenerationStep from './aiGeneration/AiGenerationStep'
import FundSelectionStep from './fundSelection/FundSelectionStep'
import { useAppSelector } from '../../store/reducers/store'
import { useNavigate, useParams } from 'react-router-dom'
import { AUTHENTICATED_ROUTES } from '../../resources/routes-constants'
import FundAllocationStep from './fundAllocation/FundAllocationStep'
import FundFeesStep from './fundFees/FundFeesStep'
import FundSummaryStep from './fundSummary/FundSummaryStep'
import PortfolioDocumentationStep from './portfolioDocumentation/PortfolioDocumentationStep'
import UploadDocumentsStep from './uploadDocuments/UploadDocumentsStep'

const CreateStepSelector: React.FC = () => {
  const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
  const { step } = useParams();
  const navigate = useNavigate();
  const stepAsInt = parseInt(step ? step : '0')

  // useEffect(() => {
  //   if (portfolio && stepAsInt > 0 && (portfolio.name === "" || portfolio.name === undefined)) {
  //     navigate(AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_STEP_ROUTE.replace(":step", "0"));
  //   }
  // }, [portfolio, stepAsInt, navigate]);

  switch (stepAsInt) {
    case 0:
      return <CreateFirstStep />;
    case 1:
      return <AiGenerationStep />;
    case 2:
      return <FundSelectionStep />;
    case 3:
      return <FundAllocationStep />;
    case 4:
      return <FundFeesStep />;
    case 5:
      return <FundSummaryStep />;
    case 6:
      return <PortfolioDocumentationStep />;
    case 7:
      return <UploadDocumentsStep />;
    case 8:
      return <UploadDocumentsStep />;
  }
  return <></>
}

export default CreateStepSelector